import { Component, Inject, OnInit } from '@angular/core';
import { ALAIN_I18N_TOKEN, SettingsService } from '@delon/theme';
import { I18NService } from '@core/i18n/i18n.service';
import { PasswordService } from './password.service';

@Component({
  selector: 'layout-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport.component.less'],
})
export class LayoutPassportComponent implements OnInit{
  langs: any[];
  constructor(
    private passwordService:PasswordService,
    public settings: SettingsService,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    ) {
    this.langs = this.i18n.getLangs();
  }

  change(lang: string) {
    this.i18n.use(lang);
    this.settings.setLayout('lang', lang);
  }

  links = [
    /*{
      title: '帮助',
      href: '',
    },
    {
      title: '隐私',
      href: '',
    },
    {
      title: '条款',
      href: '',
    },*/
  ];

  ngOnInit(): void {
    let currentLang = this.i18n.currentLang;
    this.change(currentLang);
  }


}
